<template>
    <div>
        <v-card>
            <v-toolbar color="indigo" dense>
                <v-toolbar-title class="white--text">
                    Stampa Etichetta
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            class="mr-5"
                            @click="GetEtichettaPDF"
                            small
                        >
                            <v-icon color="success"> mdi-printer-eye </v-icon>
                        </v-btn>
                    </template>
                    <span>Visualizza stampa </span>
                </v-tooltip>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            class="mr-5"
                            @click="closeStampaEtichetta"
                            small
                        >
                            <v-icon color="error"> mdi-close </v-icon>
                        </v-btn>
                    </template>
                    <span>Chiudi</span>
                </v-tooltip>
            </v-toolbar>
            <v-container>
                <v-row>
                    <v-col cols="5">
                        <v-select
                            v-model="idMacchinaTemp"
                            :items="MacchinaLista"
                            label="Macchine di tipo stampante"
                            item-text="des_macchina"
                            item-value="id_macchina"
                        >
                        </v-select>
                    </v-col>
                    <v-col cols="2">
                        <v-select
                            v-model="id_packaging"
                            :items="articoloPackaging"
                            label="Articolo Imballaggio"
                            item-text="cod_articolo_packaging"
                            item-value="id_articolo_packaging"
                            @change="getPackagingLabel"
                        >
                        </v-select>
                    </v-col>
                    <v-col cols="2">
                        <v-autocomplete
                            v-show="id_packaging > 0"
                            @change="filterLabel"
                            :items="items_tipologia"
                            item-text="des_tipologia"
                            item-value="value"
                            label="Tipologia"
                            v-model="id_tipologia"
                        />
                    </v-col>
                    <v-col v-show="id_tipologia != null" cols="3">
                        <v-select
                            v-model="id_packaging_label"
                            :items="PackagingLabel"
                            placeholder="Etichetta di Imballaggio"
                            label="Etichetta di Imballaggio"
                            item-text="cod_report"
                            item-value="id_articolo_packaging_label"
                        >
                        </v-select>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>

        <v-dialog v-model="pdfdialog" width="70vw" height="300px">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text">
                        Stampa Etichetta
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mr-5"
                                @click="StampaEtichetta"
                                small
                            >
                                <v-icon color="success">
                                    mdi-printer-check
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>invia stampa </span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mr-5"
                                @click="pdfdialog = false"
                                small
                            >
                                <v-icon color="error"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <vue-pdf-embed :source="this.selected_pdf"></vue-pdf-embed>
                    <!-- <iframe
         
            :src="this.selected_pdf"
            frameborder="0"
            style="
              display: block;
              height: 80vh !important;
              width: 80vw !important;
            "
          ></iframe> -->
                </v-card-text>
            </v-card>

            <SnackbarQV ref="SnackbarQVEtichetta" />
        </v-dialog>
        <!-- Snackbar -->
        <SnackbarQV ref="SnackbarQV" />
    </div>
</template>

<script>
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
    name: "Stampe",
    props: ["id_ArticoloTemp", "idCommessaDettaglio", "workorder"],
    components: {
        VuePdfEmbed,
        SnackbarQV,
    },
    data() {
        return {
            partProgramDialog: false,
            StampaEttichetaDialog: false,
            idMacchinaTemp: null,
            idArticoloTemp: null,
            id_packaging: null,
            ragione_sociale: null,
            id_packaging_label: null,
            id_commessa_dettaglio: null,
            id_tipologia: null,
            id_macchina: null,
            pdfdialog: false,
            selected_pdf: null,
            MacchinaLista: [],
            PackagingLabel: [],
            tmpPackagingLabel: [],
            articoloPackaging: [],
            items_tipologia: [
                { des_tipologia: "Standard", value: 0 },
                { des_tipologia: "Controetichetta", value: 1 },
            ],
        };
    },
    methods: {
        resizePdf() {
            const canvas = this.$refs.pdfdiv.getElementsByTagName("canvas")[0];
            canvas.style.objectFit = "contain";
            canvas.style.maxWidth = "100vw";
            canvas.style.maxHeight = "100vh";
        },
        getMacchinaList() {
            let manu_detail = {
                controller: "Manutenzione",
                method: "POST",
                richiesta: {
                    action: "getlistamacchine",
                    token: localStorage.getItem("user_token"),
                    id_commessa_dettaglio: this.idCommessaDettaglio,
                },
            };
            this.loading = true;
            this.progressBar = true;
            this.$store.dispatch("api", manu_detail).then((res) => {
                this.MacchinaLista = res.data.macchine.filter(
                    (it) => it.tipo_macchina === "PRN"
                );

                if (this.MacchinaLista.length === 1) {
                    this.idMacchinaTemp = this.MacchinaLista[0].id_macchina;
                }
            });
        },
        filterLabel() {
            this.PackagingLabel = this.tmpPackagingLabel;
            this.PackagingLabel = this.PackagingLabel.filter(
                (it) => it.tipologia === this.id_tipologia
            );
        },
        getArticoloPackaging() {
            console.log(JSON.stringify(this.workorder));
            let getPackaging = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getarticolipackaging",
                    token: localStorage.getItem("user_token"),
                    id_articolo: this.idArticoloTemp,
                    id_commessa: this.workorder.id_commessa,
                },
            };
            this.$store
                .dispatch("api", getPackaging)
                .then((res) => {
                    // Se la risposta arriva fermo l'overlay di caricamento
                    this.caricamento_dati = false;

                    if (res.status === 200) {
                        // Se la risposta è ok, registro i dati che mi sono arrivati
                        this.articoloPackaging = Array.from(res.data);

                        let predefinito_presente = 0;
                        let predefinito_per_cliente_presente = 0;

                        // Cerco il predefinito per cliente.
                        this.articoloPackaging.forEach((it) => {
                            if (
                                it.id_articolo_packaging ===
                                it.id_commessa_packaging_cliente
                            ) {
                                this.id_packaging = it.id_articolo_packaging;
                                this.getPackagingLabel();
                                predefinito_per_cliente_presente = 1;
                            } else {
                                console.log(
                                    it.id_articolo_packaging,
                                    it.id_commessa_packaging_cliente
                                );
                            }
                        });

                        /* Se non ho trovatov il predefinito per
                         *  cliente cerco il predefinito. */
                        if (predefinito_per_cliente_presente == 0) {
                            this.articoloPackaging.forEach((it) => {
                                if (it.predefinito === 1) {
                                    this.id_packaging =
                                        it.id_articolo_packaging;
                                    this.getPackagingLabel();
                                    predefinito_presente = 1;
                                }
                            });
                        }

                        /* Se non c'è un predefinito per cliente e nemmeno un predefinito,
                         * carico dei dati di default in base a quello che ho in mano. */
                        if (
                            predefinito_presente == 0 &&
                            predefinito_per_cliente_presente == 0
                        ) {
                            this.id_packaging =
                                this.articoloPackaging[0].id_articolo_packaging;
                            this.getPackagingLabel();
                        }
                    }
                })
                .catch(() => {
                    // Se c'è stato un errore fermo l'overlay di caricamento e stampo un avviso
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
        },
        getPackagingLabel() {
            let i = this.articoloPackaging.findIndex(
                (it) => it.id_articolo_packaging === this.id_packaging
            );
            this.ragione_sociale = this.articoloPackaging[i].ragione_sociale;
            let getPackagingLabel = {
                controller: "Label",
                method: "POST",
                richiesta: {
                    action: "getpackaginglabel",
                    token: localStorage.getItem("user_token"),
                    id_articolo_packaging: this.id_packaging,
                },
            };
            this.$store
                .dispatch("api", getPackagingLabel)
                .then((res) => {
                    // Se la risposta arriva fermo l'overlay di caricamento
                    this.caricamento_dati = false;

                    if (res.status === 200) {
                        console.log("entrato 1");
                        // Se la risposta è ok, registro i dati che mi sono arrivati
                        this.tmpPackagingLabel = Array.from(res.data);
                        this.PackagingLabel = Array.from(res.data);
                        console.log(JSON.stringify(this.PackagingLabel));

                        this.PackagingLabel.forEach((it) => {
                            if (it.tipologia === 0) {
                                this.id_tipologia = 0;
                                this.id_packaging_label =
                                    it.id_articolo_packaging_label;
                            } else {
                                this.id_tipologia = 1;
                                this.id_packaging_label =
                                    this.PackagingLabel[0].id_articolo_packaging_label;
                            }
                        });
                    } else {
                        // Se ci sono stati problemi stampo un avviso
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch(() => {
                    // Se c'è stato un errore fermo l'overlay di caricamento e stampo un avviso
                    this.caricamento_dati = false;
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                });
        },
        closeStampaEtichetta() {
            this.idMacchinaTemp = null;
            this.idArticoloTemp = null;
            this.id_packaging = null;
            this.articoloPackaging = [];
            this.id_packaging_label = null;
            this.id_tipologia = null;
            this.PackagingLabel = [];
            this.ragione_sociale = null;
            this.cod_articolo = null;
            this.quantita = null;

            this.$emit("click_chiudi");
        },
        GetEtichettaPDF() {
            this.loading = true;
            let i = this.PackagingLabel.findIndex(
                (pack) =>
                    pack.id_articolo_packaging_label === this.id_packaging_label
            );
            let cod_report = this.PackagingLabel[i].cod_report;
            const request = {
                controller: "report",
                method: "POST",
                richiesta: {
                    action: "getreportpdf",
                    token: localStorage.user_token,
                    cod_report: cod_report,
                    id_versione_articolo_packaging_label:
                        this.PackagingLabel[i]
                            .id_versione_articolo_packaging_label,
                    parametri: [
                        {
                            parametro: "@id_articolo_packaging",
                            valore: this.id_packaging,
                        },
                        {
                            parametro: "@id_commessa_dettaglio",
                            valore: this.id_commessa_dettaglio,
                        },
                    ],
                },
            };
            this.$store
                .dispatch("api", request)
                .then(async (res) => {
                    if (res.status === 200) {
                        if (
                            "tipo_messaggio" in res.data &&
                            "query_messaggio" in res.data &&
                            res.data.tipo_messaggio == 1
                        ) {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                res.data.query_messaggio
                            );
                        }
                        const byteCharacters = atob(res.data.result);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], {
                            type: "application/pdf",
                        });
                        const blobUrl = URL.createObjectURL(blob);
                        this.selected_pdf = blobUrl;
                        this.pdfdialog = true;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Invio di stampa non riuscito"
                        );
                        this.loading = false;
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    if (
                        "tipo_messaggio" in err.response.data &&
                        "query_messaggio" in err.response.data &&
                        err.response.data.tipo_messaggio == 2
                    ) {
                        this.$refs.SnackbarQV.print(
                            "error",
                            err.response.data.query_messaggio
                        );
                    } else {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Invio di stampa non riuscito"
                        );
                    }
                });
        },
        async StampaEtichetta() {
            this.loading = true;
            let i = this.PackagingLabel.findIndex(
                (pack) =>
                    pack.id_articolo_packaging_label === this.id_packaging_label
            );
            let cod_report = this.PackagingLabel[i].cod_report;
            try {
                let that = this;

                await new Promise((resolve, reject) => {
                    const request = {
                        controller: "quickconnext",
                        endpoint: "connext",
                        response: { parse: false },
                        body: {
                            action: "remoteprint",
                            token: localStorage.getItem("user_token"),
                            id_macchina: that.idMacchinaTemp,
                            cod_report: cod_report,
                            parametri: [
                                {
                                    parametro: "@id_articolo_packaging",
                                    valore: this.id_packaging,
                                },
                                {
                                    parametro: "@id_commessa_dettaglio",
                                    valore: this.id_commessa_dettaglio,
                                },
                            ],
                        },
                        method: "PUT",
                        on: {
                            load: function (response) {
                                that.$refs.SnackbarQVEtichetta.print(
                                    "success",
                                    "Stampa inviata con successo"
                                );
                                resolve(response);
                            },
                            error: function (error) {
                                /* Se la chiamata è in 400 la macchina non è
                                 * raggiungibile, quindi stampo un avviso. */
                                if (error.currentTarget.status == 400) {
                                    that.$refs.SnackbarQVEtichetta.print(
                                        "error",
                                        "Box non raggiungibile."
                                    );
                                } else {
                                    /* Se l'errore non è un 400 stampo un errore generico. */
                                    that.$refs.SnackbarQVEtichetta.print(
                                        "error",
                                        "Invio di stampa non riuscito."
                                    );
                                }
                                reject();
                            },
                        },
                    };
                    this.NETWORK.AjaxRequest(request);
                });
            } catch (error) {
                console.error(error);
            }
        },
    },

    mounted() {
        this.idArticoloTemp = this.id_ArticoloTemp;
        this.getArticoloPackaging();
        this.id_commessa_dettaglio = this.idCommessaDettaglio;
        this.NETWORK = this.$store.state.Network;
        this.getMacchinaList();
    },
};
</script>

<style></style>
